<section class="breadcrumb-banner">
    <div class="container">
        <div class="row">
            <div class="col-md-12 col-lg-12">
                <div class="breadcrumb-text">
                    <h1>
                        21st Nanded District Badminton Championship 2025
                    </h1>
                </div>
            </div>
        </div>
    </div>
    <div class="breadcrumb-bottom-img">
        <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png">
    </div>
</section>

<section class="section section-sm fide-chesscompetition section-banner-bg-1">
    <div class="container">
        <div class="sec-title text-center mb-5">
            <h2><span> 21st Nanded District Badminton Championship 2025 </span></h2>
        </div>
        <p>The <b>21st Nanded District Badminton Championship 2025 – Yonex Sunrise G H Raisoni Memorial</b> was
            conducted with
            great success on <b>9th and 10th August 2025 at Nanded Club, Nanded,</b> under the able supervision of
            Referee
            <b>Aniket Waghmare.</b> The championship drew an impressive <b>120 entries</b>, featuring <b>93 talented
                players</b>, who
            together competed in <b>107 matches across 13 events</b>, making it a vibrant showcase of sporting
            excellence. The
            tournament not only provided a platform for emerging players to demonstrate their skills but also reinforced
            the importance of nurturing competitive sportsmanship within the district. The <b>Prize Distribution
                Ceremony</b>
            was honoured by the gracious presence of distinguished guests – <b>Shri Prakash Sakhre, Dr Mane, Shri
                Santosh
                Jathale, Shri Vaibhav Deshmukh, Hon. Dr Parag Khadke (Dean of Faculties of Humanity, Swami Ramanand
                Teerth
                Marathwada University, Nanded), and Hon. Shri Mahesh Wakradkar (Secretary, Nanded City & District
                Badminton
                Association)</b> – whose encouragement and support added immense value to the occasion. Their presence
            highlighted the collective commitment to promoting badminton at the grassroots level and inspiring young
            athletes to pursue excellence. The event was a resounding success, reflecting the growing stature of
            badminton in the region and further strengthening the legacy of the G H Raisoni Memorial.
        </p>
        <div class="lightBox--gallery">
            <ul class="list-unstyled lightgallery justify-content-center row row-cols-1 row-cols-md-4">
                <li class="col"
                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/nanded-district-badminton/nanded-dis-bad-1.webp"
                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/nanded-district-badminton/nanded-dis-bad-1.webp">
                    <a href="Javascript:void(0);">
                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/nanded-district-badminton/nanded-dis-bad-1.webp"
                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                        <div class="light-gallery-poster">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png"
                                alt="GHRSCF" />
                        </div>
                    </a>
                </li>
                <li class="col"
                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/nanded-district-badminton/nanded-dis-bad-2.webp"
                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/nanded-district-badminton/nanded-dis-bad-2.webp">
                    <a href="Javascript:void(0);">
                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/nanded-district-badminton/nanded-dis-bad-2.webp"
                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                        <div class="light-gallery-poster">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png"
                                alt="GHRSCF" />
                        </div>
                    </a>
                </li>
                <li class="col"
                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/nanded-district-badminton/nanded-dis-bad-3.webp"
                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/nanded-district-badminton/nanded-dis-bad-3.webp">
                    <a href="Javascript:void(0);">
                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/nanded-district-badminton/nanded-dis-bad-3.webp"
                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                        <div class="light-gallery-poster">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png"
                                alt="GHRSCF" />
                        </div>
                    </a>
                </li>

                <li class="col"
                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/nanded-district-badminton/nanded-dis-bad-4.webp"
                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/nanded-district-badminton/nanded-dis-bad-4.webp">
                    <a href="Javascript:void(0);">
                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/nanded-district-badminton/nanded-dis-bad-4.webp"
                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                        <div class="light-gallery-poster">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png"
                                alt="GHRSCF" />
                        </div>
                    </a>
                </li>
                <li class="col"
                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/nanded-district-badminton/nanded-dis-bad-5.webp"
                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/nanded-district-badminton/nanded-dis-bad-5.webp">
                    <a href="Javascript:void(0);">
                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/nanded-district-badminton/nanded-dis-bad-5.webp"
                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                        <div class="light-gallery-poster">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png"
                                alt="GHRSCF" />
                        </div>
                    </a>
                </li>
                <li class="col"
                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/nanded-district-badminton/nanded-dis-bad-6.webp"
                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/nanded-district-badminton/nanded-dis-bad-6.webp">
                    <a href="Javascript:void(0);">
                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/nanded-district-badminton/nanded-dis-bad-6.webp"
                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                        <div class="light-gallery-poster">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png"
                                alt="GHRSCF" />
                        </div>
                    </a>
                </li>
                <li class="col"
                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/nanded-district-badminton/nanded-dis-bad-7.webp"
                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/nanded-district-badminton/nanded-dis-bad-7.webp">
                    <a href="Javascript:void(0);">
                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/nanded-district-badminton/nanded-dis-bad-7.webp"
                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                        <div class="light-gallery-poster">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png"
                                alt="GHRSCF" />
                        </div>
                    </a>
                </li>
                <li class="col"
                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/nanded-district-badminton/nanded-dis-bad-8.webp"
                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/nanded-district-badminton/nanded-dis-bad-8.webp">
                    <a href="Javascript:void(0);">
                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/nanded-district-badminton/nanded-dis-bad-8.webp"
                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                        <div class="light-gallery-poster">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png"
                                alt="GHRSCF" />
                        </div>
                    </a>
                </li>

            </ul>
        </div>
    </div>
</section>
